import {useTranslation} from 'react-i18next';
import * as css from './MarketingRow.css';
import ModeBtn from '../../../../../../../component/modeBtn/ModeBtn';
import {updateMessage} from '../../../../../../../redux/promotion/promotionActions';
import PromotionAdDetails from './promotionAdDetails/PromotionAdDetails';
import {useState} from 'react';

function MarketingRow({message, messageIndex}) {
    const {t} = useTranslation('promotionMessage');
    const [detailsOpenId, setDetailsOpenId] = useState(null);
    const [eventsOpenId, setEventsOpenId] = useState(null);
    const COLLAPSED_HEIGHT = 45;
    const EXPANDED_HEIGHT = 90;
    const EVENT_ITEM_HEIGHT = 30;
    const isDetailsOpen = detailsOpenId === message.pmid;
    const isEventListOpen = eventsOpenId === message.pmid;

    const activeMessage = async () => {
        await updateMessage(message.pmid, {active: !message.active});
    };

    const getRowHeight = (message: any, isDetailsOpen: boolean, isEventListOpen: boolean) => {
        let rowHeight = COLLAPSED_HEIGHT;
        if(isDetailsOpen) {
            if(isEventListOpen) {
                const eventCount = message.eventList?.length || 1;
                const dynamicHeight = EXPANDED_HEIGHT + (eventCount * EVENT_ITEM_HEIGHT);
                rowHeight = dynamicHeight;
            } else {
                rowHeight = EXPANDED_HEIGHT;
            }
        }
        return rowHeight;
    };
    const onToggle = () => setDetailsOpenId(detailsOpenId === message.pmid ? null : message.pmid);
    const rowHeight = getRowHeight(message, isDetailsOpen, isEventListOpen);

    return (
        <css.container rowHeight={rowHeight}>
            <css.row onClick={onToggle}>
                <css.item>
                    {t(message.type)}
                </css.item>
                <css.edit>
                    {t('edit')}
                </css.edit>
                <css.boldItem>
                    {message.events || 0}
                </css.boldItem>
                <css.boldItem>
                    {message.viewAmount || 0}
                </css.boldItem>
                <css.boldItem>
                    {message.sendClickAmount || 0}
                </css.boldItem>
                <css.toggle>
                    <ModeBtn className="" click={activeMessage} status={message.active} requestStatus={undefined} dataTitle={''} text={''} dataCyName={'activeMessage'}/>
                </css.toggle>
            </css.row>
            {isDetailsOpen && (
                <PromotionAdDetails
                    message={message}
                    onEventListToggle={() => setEventsOpenId(eventsOpenId === message.pmid ? null : message.pmid)}
                    messageIndex={messageIndex}
                    eventsOpen={isEventListOpen}
                />
            )}
        </css.container>
    );
}
export default MarketingRow;
